import { render, staticRenderFns } from "./Laason.vue?vue&type=template&id=aea2573a&scoped=true&"
import script from "./Laason.vue?vue&type=script&lang=js&"
export * from "./Laason.vue?vue&type=script&lang=js&"
import style0 from "./Laason.vue?vue&type=style&index=0&id=aea2573a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea2573a",
  null
  
)

export default component.exports